import { useTranslation } from 'react-i18next';
import SelectField from '../../../../../components/fields/SelectField';
import TranslatedInputField from '../../../../../components/fields/TranslatedInputField';
import useSystemOptions from '../../../../../utilities/useSystemOptions';

type RouterMenuItemLogoutProps = {
    name: string;
};

const RouterMenuItemLogout = ({ name }: RouterMenuItemLogoutProps) => {
    const { t } = useTranslation('routerDetails');
    const { antdIconOptions } = useSystemOptions();

    return (
        <>
            <TranslatedInputField
                {...t('routerDetails:menuItems.fields.label', { returnObjects: true })}
                name={`${name}.label`}
                required
            />

            <SelectField
                {...t('routerDetails:menuItems.fields.icon', { returnObjects: true })}
                name={`${name}.icon`}
                options={antdIconOptions}
                showSearch
            />
        </>
    );
};

export default RouterMenuItemLogout;
